import React from "react";
import styles from "./InfoGridOffer.module.css";
import { difficultyImages } from "../../../data/difficultyImages";

function InfoGridOffer({ duration, maxGuests, overalleLevel }) {
  return (
    <div className={`infoGridContainer  ${styles.backgroundInfoGrid}`}>
      <div className={`row ${styles.rowAlignCenter}`}>
        <div className={`col ${styles.textLeft}`}>
          <strong>Dauer:</strong> {duration}
        </div>
        <div className={`col ${styles.textLeft}`}>
          <strong>max Personen:</strong> {maxGuests}
        </div>

        <div className={`row ${styles.rowAlignCenter}`}>
      <div className={`col ${styles.textLeft}`}>
        <div className={styles.anspruchContainer}>
          <strong className={styles.anspruchText}>Anspruch:</strong>
          <img
            src={difficultyImages[overalleLevel]}
            alt={`Difficulty Level ${overalleLevel}`}
            className={styles.difficultyImage}
          />
        </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoGridOffer;
